<template>
    <!-- INICIO INFORMATIVOS -->
    <div class="wallet__infos">
        <div class="row align-items-center no-gutters">

            <!-- INICIO DESCRIÇÃO -->
            <div class="col-12 col-md-7 col-lg-8">
                <div class="row">
                    <div class="col-12 col-md-4 col-lg-4">
                        <div class="wallet__infos--pad">
                            <span>Saldo disponível:</span>  
                            <strong class="saldo">{{ formatadoSaldo }} </strong>
                            <at-popover trigger="hover" placement="right" content="Saldo disponível para saque!">
                                <i class="fas fa-info-circle"></i>
                            </at-popover>
                        </div>
                    </div>
                </div>
            </div>
            <!-- FINAL DESCRIÇÃO -->

            <!-- INCIOS AÇÕES -->
            <div class="col-12 col-md-5 col-lg-4 sep">
                <span>Transferir saldo para</span>
                <router-link 
                    to="/investimentos/carteira-investimento/transferir-fundos" 
                    class="btn btn-primary" 
                    title="Transferir saldo para conta bancária"
                >
                    Conta bancária
                </router-link>

                <router-link saldo
                    to="/investimentos/oportunidades" 
                    class="btn btn-primary" 
                    title="Reinvestir saldo"
                >
                    <i class="ico-din-5"></i> 
                    <span>Reinvestir</span>

                </router-link>
            </div>
            <!-- FINAAL AÇÕES -->
        </div>
    </div>
    <!-- FINAL INFORMATIVOS -->
</template>

<script>
    export default {
        props: ['saldo'],

        computed: {
            formatadoSaldo() {
                return this.formatarDinheiro(Math.floor(this.saldo * 100) / 100);
            },
        },

        methods: {
            formatarDinheiro(value) {
                let options = { 
                        minimumFractionDigits: "2", 
                        maximumFractionDigits: 2, 
                        style: 'currency', 
                        currency: 'BRL'
                    }

                if(value != null){

                    if(typeof value  == "string") value = parseFloat(value)

                    return value.toLocaleString('pt-BR', options )
                }
                value = 0
                
                return value.toLocaleString('pt-BR', options )
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Wallet/WalletHeader.vue